import React from 'react';
import cn from '@/utils/cn';
import { colorVariant, TNavBg } from './colorVariant';

interface SideNavDividerProps {
  color?: TNavBg;
}

const BASE = 'h-px mx-1';

const SideNavDivider = ({ color = 'navy-2' }: SideNavDividerProps) => (
  <div className={cn(BASE, colorVariant({ bg: color }))} />
);

export default SideNavDivider;
